import Stack from '@mui/material/Stack';
import ControlState from '../Shared/controlState';
import RemoveControlPopoverContent from './RemoveControlPopoverContent';
import RemovePagePopoverContent from './RemovePagePopoverContent';
import MoveComponentPopoverContent from './MoveComponentPopoverContent';

export enum PopoverKind {
  REMOVE_CONTROL,
  REMOVE_PAGE,
  MOVE_PAGE
}

export default (props: {
  popoverKind: PopoverKind | null;
  control: ControlState;
  onClose: () => void;
}) => {
  const { popoverKind, control, onClose } = props;

  const getPopoverContent = () => {
    switch (popoverKind) {
      case PopoverKind.REMOVE_CONTROL:
        return (
          <RemoveControlPopoverContent control={control} onClose={onClose} />
        );
      case PopoverKind.REMOVE_PAGE:
        return <RemovePagePopoverContent control={control} onClose={onClose} />;
      case PopoverKind.MOVE_PAGE:
        return (
          <MoveComponentPopoverContent control={control} onClose={onClose} />
        );
      case null:
        return null;
    }
  };

  return <Stack p={2}>{getPopoverContent()}</Stack>;
};
